/**
 * Brand slug — the dimension legal content, versions, and consent state are
 * scoped by (ADR-088 — per-brand legal content distribution). kukla.tech
 * sp. z o.o. operates two platforms (KiedyNabory.pl, HotelB2B) that used to
 * share one Regulamin/Polityka; the new Regulamin's anti-scraping / "Baza
 * Danych o Naborach" clauses (§5.5–5.8, 6.3, 6.5) apply to KiedyNabory only,
 * so each brand now has its own document.
 */
export type BrandSlug = 'kiedynabory' | 'hotelb2b';

/**
 * Canonical, ordered list — single source of truth for "which brands exist".
 * Adding a 3rd brand means one entry here plus a `content/<brand>/` folder
 * and a `LEGAL_VERSIONS_BY_BRAND` entry — zero signature changes anywhere
 * else (OCP).
 */
export const BRAND_SLUGS: readonly BrandSlug[] = ['kiedynabory', 'hotelb2b'];

/**
 * The brand used on the VERSION-COMPARISON fallback path only (ADR-088
 * "Failure mode"). An unknown/missing `brandSlug` passed to
 * `currentVersion`/`isVersionCurrent` resolves here instead of throwing.
 * NEVER used on the content path (`getSanitizedHtml`/`getCurrentVersionEntry`),
 * which throws instead (fail-closed, C1) — `kiedynabory` is simply the
 * historical default, from before this package supported more than one brand.
 */
export const FALLBACK_BRAND_SLUG: BrandSlug = 'kiedynabory';

/** Type guard — `true` only for a recognized, currently-registered brand slug. */
export function isKnownBrandSlug(slug: unknown): slug is BrandSlug {
  return (
    typeof slug === 'string' && (BRAND_SLUGS as readonly string[]).includes(slug)
  );
}
